<!-- 保证金模式 -->
<template>
  <c-dialog
    paddingTop="16px"
    paddingBottom="0"
    class="depositModeDialog"
    :showFlag="isShow"
    :confirmLoading="dialogConfirmLoading"
    :confirmDisabled="dialogConfirmDisabled"
    :confirmText="confirmText"
    :titleText="titleText"
    :hideCancel="true"
    @close="close"
    @confirm="submit">
    <!--保证金模式-->
    <p class="mode-title">{{ $t('futures.depositMode.text12') }}</p>
    <div class="depositMode-box">
      <div class="category-select-box">
        <span class="tab" v-for="(item, index) in categoryList" :key="index" @click="selectCategory(item.id)" :class="item.classes">
          {{item.text}}
        </span>
      </div>
      <div class="text gray-cl">
        <template v-if="marginModel === 1">
          <!-- 全仓保证金模式: 所有仓位共用合约账户中的保证金来避免仓位被强平。在强平事件中，交易者可能会损失所有的保证金和仓位。 -->
          <p v-html="lanText.text1"></p>
        </template>
        <template v-else>
          <!-- 逐仓保证金模式: 一定数量保证金被分配到仓位上。如果仓位保证金亏损到低于维持保证金的水平，仓位将被强平。在逐仓模式下，您可以为这个仓位添加和减少保证金。 -->
          <p v-html="lanText.text2"></p>
        </template>
      </div>
    </div>
    <!--仓位模式-->
    <p class="mode-title">{{ $t('futures.depositMode.position_mode') }}</p>
    <div class="depositMode-box">
      <div class="category-select-box">
        <span class="tab" v-for="(item, index) in modeList" :key="index" @click="selectMode(item.id)" :class="item.classes">
          {{item.text}}
        </span>
      </div>
      <div class="text gray-cl">
        <template v-if="positionLayout === 1">
          <!-- 合仓模式: 同一方向（开多或开空）且同一交易对下单将合并为一个仓位。同一交易对最多只有多仓和空仓两个仓位。同一交易对的所有仓位杠杆只能在下单区域统一调整。调整后 ，持仓仓位会按最新杠杆倍数显示。 -->
          <p v-html="$t('futures.depositMode.merge_mode')"></p>
        </template>
        <template v-else>
          <!-- 分仓模式：同一方向（开多或开空）且同一交易对下可开设多个仓位，分仓模式下新开单不会与已有仓位合并，同一交易对可有多个多仓和空仓仓位。各仓位可享有独立杠杆倍数，下单区的杠杆倍数只影响新下单的仓位。 -->
          <p v-html="$t('futures.depositMode.split_mode')"></p>
        </template>
      </div>
    </div>
  </c-dialog>
</template>

<script>
import '@/components/modules/coTrade/style/depositMode.scss';

export default {
  mounted() {
    this.init();
  },
  data() {
    return {
      marginModel: 1, // 保证金模式 全仓|逐仓
      positionLayout: 1, // 仓位模式 分仓|合仓
      // 是否加载成功
      dialogConfirmLoading: false,
      // 是否禁止提交
      dialogConfirmDisabled: false,
    };
  },
  props: {
    isShow: {
      default: false,
      type: Boolean,
    },
    close: {
      default() {},
      type: Function,
    },
  },
  computed: {
    lanText() {
      return {
        // 全仓保证金模式: 所有仓位共用合约账户中的保证金来避免仓位被强平。在强平事件中，交易者可能会损失所有的保证金和仓位。
        text1: this.$t('futures.depositMode.text1'),
        // 逐仓保证金模式: 一定数量保证金被分配到仓位上。如果仓位保证金亏损到低于维持保证金的水平，仓位将被强平。在逐仓模式下，您可以为这个仓位添加和减少保证金。
        text2: this.$t('futures.depositMode.text2'),
        text3: this.$t('futures.depositMode.text3'), // 设置为全仓模式
        text4: this.$t('futures.depositMode.text4'), // 设置为逐仓模式
        text5: this.$t('futures.depositMode.text5'), // 请登录后再进行操作
        text6: this.$t('futures.depositMode.text6'), // 已是全仓模式
        text7: this.$t('futures.depositMode.text7'), // 已是逐仓模式
        text8: this.$t('futures.depositMode.text8'), // 持有仓位/有挂单时不可改变保证金模式
        text9: this.$t('futures.depositMode.text9'), // 全仓
        text10: this.$t('futures.depositMode.text10'), // 逐仓
        text12: this.$t('futures.depositMode.text12'), // 保证金模式
      };
    },
    // 提交保证金按钮文案
    confirmText() {
      // // '设置为全仓模式' : '设置为逐仓模式'
      // let text = this.marginModel === 1 ? this.lanText.text3 : this.lanText.text4;
      // // '请登录后再进行操作';
      // if (!this.isLogin) {
      //   return this.lanText.text5;
      // }
      // if (this.userConfig && this.marginModel === this.userConfig.marginModel) {
      //   // '已是全仓模式' : '已是逐仓模式';
      //   text = this.marginModel === 1 ? this.lanText.text6 : this.lanText.text7;
      //   this.dialogConfirmDisabled = true;
      // }
      // if (this.userConfig && this.marginModel !== this.userConfig.marginModel) {
      //   this.dialogConfirmDisabled = false;
      // }
      // if (this.userConfig && !this.userConfig.marginModelCanSwitch) {
      //   text = this.lanText.text8; // '持有仓位/有挂单时不可改变保证金模式';
      //   this.dialogConfirmDisabled = true;
      // }
      // if (!this.userConfig) {
      //   this.dialogConfirmDisabled = true;
      // }

      const text = this.$t('application.confirm');
      // '请登录后再进行操作';
      if (!this.isLogin) {
        return this.lanText.text5;
      }

      // 交给接口做校验 - 2023-03-26
      // if (this.userConfig && !this.userConfig.marginModelCanSwitch) {
      //   text = this.lanText.text8; // '持有仓位/有挂单时不可改变保证金模式';
      //   this.dialogConfirmDisabled = true;
      // }

      if (!this.userConfig) {
        this.dialogConfirmDisabled = true;
      }

      return text;
    },
    // 保证金模式列表
    categoryList() {
      return [
        {
          id: 1,
          text: this.lanText.text9, // '全仓',
          classes: this.marginModel === 1 ? 'blue-bg white-cl' : 'gray-30-bg gray-cl',
        },
        {
          id: 2,
          text: this.lanText.text10, // '逐仓',
          classes: this.marginModel === 2 ? 'blue-bg white-cl' : 'gray-30-bg gray-cl',
        },
      ];
    },
    // 仓位模式
    modeList() {
      return [
        {
          id: 1,
          text: this.$t('futures.depositMode.merge'), // '合仓',
          classes: this.positionLayout === 1 ? 'blue-bg white-cl' : 'gray-30-bg gray-cl',
        },
        {
          id: 2,
          text: this.$t('futures.depositMode.split'), // '分仓',
          classes: this.positionLayout === 2 ? 'blue-bg white-cl' : 'gray-30-bg gray-cl',
        },
      ];
    },
    // 是否Login
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    // 用户配置信息
    userConfig() {
      return this.$store.state.future.futureUserConfig;
    },
    // 当前合约ID
    contractId() {
      return this.$store.state.future.contractId;
    },
    // 当前合约信息
    contractInfo() {
      return this.$store.state.future.contractInfo;
    },
    // 当前合约名称
    activeContractName() {
      let name = '';
      let text = '';
      if (this.contractInfo) {
        const nameText = this.contractInfo.symbol ? this.contractInfo.symbol.replace('-', '') : '';
        if (this.contractInfo.contractType !== 'E') {
          text = `-${this.contractInfo.marginCoin}`;
        }
        name = `${nameText}${text}`;
      }
      return name;
    },
    // 弹窗标题
    titleText() {
      return `${this.activeContractName} ${this.$t('futures.depositMode.tradingMode')}`; // 交易模式
    },
  },
  methods: {
    init() {
      if (this.userConfig) {
        // if (this.userConfig.marginModelCanSwitch) {
        //   this.marginModel = this.userConfig.marginModel === 1 ? 2 : 1;
        // } else {
        //   this.marginModel = this.userConfig.marginModel;
        // }
        //
        // if (this.userConfig.positionLayoutCanSwitch) {
        //   this.positionLayout = this.userConfig.positionLayout === 1 ? 2 : 1;
        // } else {
        //   this.positionLayout = this.userConfig.positionLayout || 1;
        // }

        this.marginModel = this.userConfig.marginModel || 1;
        this.positionLayout = this.userConfig.positionLayout || 1;
      }
    },

    // 切换保证金模式
    selectCategory(id) {
      this.marginModel = id;
    },

    // 切换仓位
    selectMode(id) {
      this.positionLayout = id;
    },

    // 提交保证金模式
    submit() {
      if (!this.isLogin) {
        this.$router.push('/login');
        return false;
      }

      if (this.userConfig) {
        this.dialogConfirmLoading = true;
        this.axios({
          url: this.$store.state.url.futures.marginModelEdit,
          hostType: 'co',
          method: 'post',
          params: {
            positionLayout: this.positionLayout,
            marginModel: this.marginModel,
            contractId: this.contractId,
          },
        }).then(({ code, msg }) => {
          if (code.toString() === '0') {
            this.$store.dispatch('getUserConfig');
            this.close();
            this.$bus.$emit('tip', { text: msg, type: 'success' });
          } else {
            this.$bus.$emit('tip', { text: msg, type: 'error' });
          }
          this.dialogConfirmLoading = false;
        });
      }
      return false;
    },
  },
};
</script>
